import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaQuoteLeft, FaChevronLeft, FaChevronRight, FaStar } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Shiwansh Solutions Team',
      position: 'Business Owner',
      image: '/images/shi.png', // replace with real client image/logo if available
      text: 'ZustandTech delivered a complete business website along with an internship and management system for our company. Their team understood our vision perfectly and built a scalable solution that improved our online presence and operations.',
      rating: 5,
      company: 'https://shiwansh.com/'
    },
    {
      id: 2,
      name: 'Ramkus Dairy',
      position: 'Dairy Business Owner',
      image: '/images/ram.png',
      text: 'We wanted a modern platform to showcase our dairy products and handle online orders. ZustandTech built a fast, clean, and user-friendly website that helped us reach more customers and grow our business.',
      rating: 5,
      company: 'http://ramkusdairy.shop/'
    },
    {
      id: 3,
      name: 'DBK Infra',
      position: 'Infrastructure Company',
      image: '/images/dhk.png',
      text: 'ZustandTech created a professional website for our infrastructure business with a strong focus on branding and performance. The final product exceeded our expectations and represents our company perfectly.',
      rating: 5,
      company: 'https://dbkinfra.com/'
    },
    {
      id: 4,
      name: 'RailWorks Fleet',
      position: 'Fleet Management Company',
      image: '/images/rail.png',
      text: 'Their team developed a powerful and responsive platform for our fleet services. The design, performance, and usability were top-notch. We highly appreciate their professionalism and timely delivery.',
      rating: 5,
      company: 'https://railworksfleet.com/'
    },
    {
      id: 5,
      name: 'EMS System Users',
      position: 'HR & Operations Team',
      image: '/images/ems.png',
      text: 'The Employee Management System built by ZustandTech streamlined our internal operations. From attendance to productivity tracking, everything is now efficient and easy to manage.',
      rating: 5,
      company: 'https://ems.shiwansh.com/login'
    },
    {
      id: 6,
      type: 'project',
      name: 'ZustandTech Smart Billing System',
      position: 'Business Owner',
      image: '/images/ztb.png',
      text: 'The Smart Billing System built by ZustandTech revolutionized our invoice generation and GST management. From customer management to real-time reports, everything is now efficient and easy to manage.',
      rating: 5,
      technologies: ['React', 'Node.js', 'MongoDB', 'Express'],
      link: 'https://www.billingzustandtech.com',
      category: 'web'
    },
    {
      id: 7,
      type: 'project',
      name: 'Pneumonia Detection AI Tool',
      position: 'Healthcare Professional',
      image: '/images/zt.png',
      text: 'This AI-powered medical tool has transformed how we analyze chest X-rays. Using deep learning (CNN + Grad-CAM), it detects pneumonia with remarkable accuracy, helping us make faster diagnoses.',
      rating: 5,
      technologies: ['Python', 'TensorFlow', 'Flask', 'React'],
      link: 'https://www.x-rayzustandtech.com',
      category: 'ai'
    },
    {
      id: 8,
      type: 'project',
      name: 'Solar Project Analytics Dashboard',
      position: 'Project Manager',
      image: '/images/so.png',
      text: 'Advanced analytics dashboard that transformed our solar project financials tracking. Expense tracking and performance insights are now at our fingertips.',
      rating: 5,
      technologies: ['Power BI', 'DAX', 'Excel', 'SQL'],
      link: '',
      category: 'ai'
    },
    {
      id: 9,
      type: 'project',
      name: 'Sanhai Charitable Trust',
      position: 'Trustee',
      image: '/images/shan.png',
      text: 'Compassion in Action, Hope for All — This platform empowers education, rescues animals, greening earth, and healing lives. Join the movement of change that transforms communities.',
      rating: 5,
      technologies: ['React', 'Bootstrap', 'Node.js', 'Express', 'MongoDB'],
      stats: [
        { label: 'Years of Service', value: '10+' },
        { label: 'Lives Impacted', value: '50,000+' },
        { label: 'Volunteers', value: '500+' },
        { label: 'Villages Reached', value: '100+' }
      ],
      link: 'https://sanhai-trust.org/',
      category: 'web'
    },
    {
      id: 10,
      type: 'project',
      name: 'Rent A Guava Tree',
      position: 'Farm Owner',
      image: '/images/gua.png',
      text: 'Sustainable farming initiative — Lease your own guava tree for ₹5,000 per season and receive 30-90 kg of fresh, chemical-free guavas delivered to your doorstep. A revolutionary concept!',
      rating: 5,
      technologies: ['React', 'Node.js', 'MongoDB', 'Razorpay', 'Twilio'],
      metrics: {
        treesLeased: '500+',
        activePartners: '50+',
        totalHarvest: '10,000+ kg'
      },
      link: 'https://rentaguavatree.com/',
      category: 'web'
    },
    {
      id: 11,
      type: 'project',
      name: 'City Bus Booking System',
      position: 'Transport Manager',
      image: '/images/bus.png',
      text: 'Online bus booking and management system with user registration, route tracking, and ticket booking. Made our operations seamless and efficient.',
      rating: 5,
      technologies: ['React', 'Node.js', 'MongoDB'],
      link: '',
      category: 'web'
    },
    {
      id: 12,
      type: 'project',
      name: 'Weather Analytics Dashboard',
      position: 'Meteorologist',
      image: '/images/we.png',
      text: 'Weather dashboard displaying real-time conditions, forecasts, and air quality metrics with stunning data visualization. Essential tool for our daily operations.',
      rating: 5,
      technologies: ['React', 'API Integration', 'Chart.js'],
      link: '',
      category: 'ai'
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const interval = setInterval(nextTestimonial, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonials">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="section-header"
        >
          <span className="section-subtitle">Testimonials</span>
          <h2 className="section-title">
            What Our <span className="gradient-text">Clients</span> Say
          </h2>
          <p className="section-description">
            Don't just take our word for it - hear from some of our satisfied clients
          </p>
        </motion.div>

        <div className="testimonials-container">
          <button className="nav-button prev" onClick={prevTestimonial}>
            <FaChevronLeft />
          </button>

          <div className="testimonials-wrapper">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5 }}
                className="testimonial-card"
              >
                <FaQuoteLeft className="quote-icon" />
                <div className="testimonial-content">
                  <p className="testimonial-text">"{testimonials[currentIndex].text}"</p>
                  <div className="testimonial-rating">
                    {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                      <FaStar key={i} className="star" />
                    ))}
                  </div>
                  <div className="testimonial-author">
                    <img 
                      src={testimonials[currentIndex].image} 
                      alt={testimonials[currentIndex].name}
                      className="author-image"
                    />
                    <div className="author-info">
                      <h4 className="author-name">{testimonials[currentIndex].name}</h4>
                      <p className="author-position">{testimonials[currentIndex].position}</p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <button className="nav-button next" onClick={nextTestimonial}>
            <FaChevronRight />
          </button>
        </div>

        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;